<!--
 * @Author: M.D.
 * @Date: 2019-12-10 17:14:11
 * @LastEditors  : M.D.
 * @Description: 首页容器
 * @Remarks: v-if="showHelper"
 -->
<template>
  <div class="main-index" ref="mainPage">
    <right-float-bar
      @openLoginDialog="openLoginDialog"
      @openPay="openPay"
      v-if="showHelper"
    />
    <div class="header">
      <!-- <top-header
        ref="tpHeader"
        @openCompDialog="openCompDialog"
        @openLoginDialog="openLoginDialog"
         @loginResult="loginResult">
      </top-header> -->
      <logo-header
        ref="tpHeader"
        @loginResult="loginResult"
        @openCompDialog="openCompDialog"
        @openLoginDialog="openLoginDialog"
        @openPay="openPay"
      ></logo-header>
    </div>
    <div class="main">
      <!-- <el-row :gutter="20">
        <el-col :span="20" :offset="2"> -->
      <router-view
        class="k-content"
        @openCompDialog="openCompDialog"
        @openLoginDialog="openLoginDialog"
        @openPay="openPay"
      >
      </router-view>
      <!-- </el-col>
      </el-row> -->
    </div>
    <div id="footer-esp" class="footer">
      <!-- <k-footer @openLoginDialog="openLoginDialog"></k-footer> -->
      <bottom-footer @openLoginDialog="openLoginDialog"></bottom-footer>
    </div>

    <!-- <div
      id="helper"
      class="need-help"
      ref="div"
      @click="push2QA"
      v-if="showHelper">
      <img src="@/assets/image/qaq.png" alt="">
    </div> -->
    <helper-button v-if="showHelper" />
  </div>
</template>

<script>
import TopHeader from '@/components/top-header'
import LogoHeader from '@/components/logo-header'
import KFooter from '@/components/k-footer'
import BottomFooter from '@/components/bottom-footer'
import HelperButton from '@/components/helper-button'
import RightFloatBar from '@/components/right-float-bar'
import { mapGetters } from 'vuex'
import { usrStatus } from '@/util/mixin'

export default {
  mixins: [usrStatus],
  props: {},
  data() {
    return {
      showHelperWhenScroll: true,
      showHelperInHome: true,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    showHelper() {
      return this.showHelperWhenScroll && this.showHelperInHome
    },
  },
  created() {
    //已经登录且需要全电
    if (this.$route.query.op && this.isLogin) {
      if (this.userInfo.dzswjzh) {
        this.openPay()
        //调用一键登录
      } else {
        this.$alert('您还未完善全电相关信息，请先完善信息', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showClose: false,
        }).then(() => {
          //完善信息
          this.$router.push({
            name: 'userInfo',
            query: { op: 'qd' },
          })
        })
      }
    }

    //未登录需要全电
    if (this.$route.query.op && !this.isLogin) {
      let isreg = localStorage.getItem('isreg')
      if (isreg) {
        this.$nextTick(() => {
          //打开登录框
          //this.$refs.tpHeader.toLogin()
          this.$alert('请先登录然后进入智能发票云平台', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showClose: false,
          }).then(() => {
            //完善信息
            this.$refs.tpHeader.toLogin()
          })
        })
      } else {
        this.$nextTick(() => {
          this.$confirm('系统检测到你还未注册过全电账号, 是否去注册?', '提示', {
            confirmButtonText: '去注册',
            cancelButtonText: '我已注册，去登录',
            showClose: false,
            closeOnClickModal: false,
            type: 'warning',
          })
            .then(() => {
              this.$refs.tpHeader.toRegist()
            })
            .catch(() => {
              //打开登录框
              this.$refs.tpHeader.toLogin()
            })
        })
      }
      //判断有无注册--跳转注册
      // this.$nextTick(() => {
      //   //打开登录框
      //   this.$refs.tpHeader.toLogin()
      // })
    }
  },
  mounted() {
    // if (this.showHelperWhenScroll && this.showHelperInHome) {
    //   window.addEventListener('scroll', this.handleScroll, true)
    // }
  },
  activated() {},
  deactivated() {},
  watch: {
    '$route.path': function(newVal, oldVal) {
      if (newVal === '/index') {
        this.showHelperWhenScroll = true
      } else {
        this.showHelperWhenScroll = false
      }
    },
  },
  methods: {
    loginResult(rlt) {
      //alert("loginrlt："+rlt)
      //强制刷新浮动菜单
      this.showHelperWhenScroll = false
      this.$nextTick(() => {
        this.showHelperWhenScroll = true
      })
    },
    handleScroll(e) {
      if (!e || !e.target || !e.target.documentElement) {
        return
      }
      let scrollTop = e.target.documentElement.scrollTop
      if (scrollTop && scrollTop > 1800) {
        this.showHelperInHome = false
        return
      }
      if (scrollTop && scrollTop < 1800) {
        this.showHelperInHome = true
      }
    },
    openLoginDialog() {
      this.$refs.tpHeader.toLogin()
      // this.$nextTick(() => {
      //  this.showHelperWhenScroll = true
      // })
    },
    openCompDialog() {
      // this.$refs.tpHeader._showCompD()
      // this.$refs.tpHeader.bindNewAccount()
      this.$refs.tpHeader.perfectInfo()
    },
    openPay() {
      this.$nextTick(() => {
        this.$refs.tpHeader.openPay()
      })
    },
  },
  components: {
    TopHeader,
    LogoHeader,
    KFooter,
    BottomFooter,
    HelperButton,
    RightFloatBar,
  },
}
</script>

<style lang="stylus" scoped>
.main-index {
  width: 100%;

  .main {
    min-height: calc(100vh - 454px);
    background: bg-color-f1;
    overflow: hidden;
    width: 100%;
  }
}
</style>
